// extracted by mini-css-extract-plugin
export default {"root":"subCard_root__XHcCK","title":"subCard_title__BmAyW","right":"subCard_right__iu4Kw"};